export enum CashBoxType {
  CASH = "CASH",
  CARD = "CARD"
}